import { InputText } from 'primeng/inputtext';
import { TranslateService } from '@ngx-translate/core';

import { Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { input, signal, output, inject, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { Button } from '../../ui/button';
import { SvgIcon } from '../../ui/svg-icon';
import { ToastService } from '../../ui/toast';

@Component({
  selector: 'app-tag-input',
  templateUrl: './tag-input.html',
  styleUrl: './tag-input.scss',
  standalone: true,
  imports: [InputText, SvgIcon, ReactiveFormsModule, Button],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tag-input',
  },
})
export class TagInput {
  public label = input<string>('');
  public placeholder = input<string>('');
  public addButtonLabel = input<string>('');
  public items = input<string[]>([]);
  public isItemsEmail = input<string[]>([]);

  public itemsChange = output<string[]>();
  public itemAdded = output<string>();
  public itemRemoved = output<string>();

  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  protected itemControl = new FormControl('', this.isItemsEmail() ? [Validators.email] : []);

  protected itemList = signal<string[]>([]);

  constructor() {
    this.itemList.set(this.items());
  }

  protected addItem(): void {
    const itemValue = this.itemControl.value?.trim();

    if (!itemValue || this.itemControl.invalid) {
      return;
    }

    if (this.itemList().includes(itemValue)) {
      this.toastService.error(this.translateService.instant('shared.ui.add-items-to-list.item-exist'));
      return;
    }

    const updatedList = [...this.itemList(), itemValue];
    this.itemList.set(updatedList);
    this.itemControl.reset();

    this.itemsChange.emit(updatedList);
    this.itemAdded.emit(itemValue);
  }

  protected deleteItem(index: number): void {
    const itemToRemove = this.itemList()[index];
    const updatedList = this.itemList().filter((_, i) => i !== index);

    this.itemList.set(updatedList);

    this.itemsChange.emit(updatedList);
    this.itemRemoved.emit(itemToRemove);
  }

  protected handleKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.addItem();
    }
  }
}
